import { render } from "./AccordionTitle.vue?vue&type=template&id=ce3206f8&scoped=true&ts=true"
import script from "./AccordionTitle.vue?vue&type=script&lang=ts"
export * from "./AccordionTitle.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3206f8"]])

export default __exports__